import { render, staticRenderFns } from "./KimlerForm.vue?vue&type=template&id=bf32ce04&"
import script from "./KimlerForm.vue?vue&type=script&lang=js&"
export * from "./KimlerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports